export default function getUpsellFunnelStep(checkout) {
  return checkout.funnelSteps?.find(
    step => step.enabled && step.type === 'upsell',
  );
}
